// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__E3jiU","range":"MonthRangeSwitch_range__uVOIS","disabled":"MonthRangeSwitch_disabled__1hNHL"};